import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
		isAddCart: false, //
        CartNumber: 0, //
        isLoginStatu: false, //Login Status
        userToken: '', //User Token
        userTokenKey: '', //User Token Key
        bottonLoading: false, //botton loading status
        userAvatar: '',
		userInfo:'',
        rechargeCarName: '', //recharge name
        withdrawCarName: '', //withdraw name
        messageStatus: false, //msg shou status
        moduleLoading: false, //module loading
		skeletonShow:true,
    },
    mutations: {
        $vuexSetLoginState(state, pathName) {
            state.isLoginStatu = pathName;
        },
        $vuexSetAddCart(state, pathName) {
            state.isAddCart = pathName;
        },
        $vuexSetCartNumber(state, pathName) {
            state.CartNumber = pathName;
        },
        $vuexSetUserTokenState(state, pathName) {
            state.userToken = pathName;
        },
        $vuexSetUserTokenKeyState(state, pathName) {
            state.userTokenKey = pathName;
        },
        $vuexSetBottonLoadingState(state, pathName) {
            state.bottonLoading = pathName;
        },
        $vuexSetUserAvatarState(state, pathName) {
            state.userAvatar = pathName;
        },
        $vuexSetRechargeCarNameState(state, pathName) {
            state.rechargeCarName = pathName;
        },
        $vuexSetMessageStatusState(state, pathName) {
            state.messageStatus = pathName;
        },
        $vuexSetModuleLoadingState(state, pathName) {
            state.moduleLoading = pathName;
        },
        $vuexSetWithdrawCarNameState(state, pathName) {
            state.withdrawCarName = pathName;
        },
        $vuexUserInfo(state, val) {
            state.userInfo = val;
        },
        $vuexSetSkeletonShowState(state, pathName) {
            state.skeletonShow = pathName;
        },
    }
})

export default store